import { Axios, AxiosError, HttpStatusCode } from "axios";
import { ElNotification } from "element-plus";
import { VueElement } from "vue";
import { I18n, useI18n } from "vue-i18n";

export function showResponseErrorToUser(error: unknown, t: Function) {
  const errorMessage = getResponseErrorMessage(error, t);
  ElNotification({
    title: t("error"),
    message: errorMessage,
    type: "error",
  });
}

export function getResponseErrorMessage(error: unknown, t: Function): string {
  if (error instanceof AxiosError && error.response) {
    if ((error as AxiosError)?.response?.status === HttpStatusCode.Forbidden) {
      return t("accessDenied");
    }
    if (error?.response?.data?.["error"] !== undefined) {
      return error?.response?.data?.["error"];
    }
  }
  return t("genericError");
}
